import CustomInput from './FormInput/FormInput'
import CustomSelet from './FormSelect/FormSelect'
import CustomFile from './FormFileInput/FormFileInput'
import { CategoryList } from './CategoryList/CategoryList'
import { Captcha } from './Captcha/Captcha'
import { IndependantCheck } from './IndependantCheck/IndependantCheck'
import InputWithStringLengthCheck from './FormInput/FormInputWithStringCheck'

const FormComponents = {
  Input: CustomInput,
  InputWithStringLengthCheck,
  Select: CustomSelet,
  File: CustomFile,
  Categories: CategoryList,
  Captcha,
  IndependantCheck
}

export default FormComponents
